<template lang="pug">
div#app.app
  navbar
  .app-body.app-overview
    sidebar
    main.view-x.mt-3(role="main")
      .container-fluid.animated.fadeIn
        nav(aria-label="breadcrumb")
          b-breadcrumb
            b-breadcrumb-item
              router-link(to="/overview")
                i.fa.fa-home
                span.ml-1 {{ $t("ui.overview") }}
        template(v-if="stats.details.length > 0")
          .row
            .col-lg-3.col-md-4.col-sm-6
              .card.card-glass
                .card-body.d-flex.align-items-center.p-2
                  .text-white.bg-primary.p-2.mr-3
                    i.icon-user.text-lg
                  .text-left
                    .fs-6.fw-semibold.text-danger
                      b {{ stats.details[0].ag_count }}
                    .text-medium-emphasis.text-uppercase.fw-semibold.small {{ $t("ui.total") }}
            .col-lg-3.col-md-4.col-sm-6
              .card.card-glass
                .card-body.d-flex.align-items-center.p-2
                  .text-white.bg-primary.p-2.mr-3
                    i.icon-user.text-lg
                  .text-left
                    .fs-6.fw-semibold.text-danger
                      b {{ stats.details[0].ag_count_active }}
                    .text-medium-emphasis.text-uppercase.fw-semibold.small {{ $t("ui.active") }}
            .col-lg-3.col-md-4.col-sm-6
              .card.card-glass
                .card-body.d-flex.align-items-center.p-2
                  .text-white.bg-primary.p-2.mr-3
                    i.icon-user.text-lg
                  .text-left
                    .fs-6.fw-semibold.text-danger
                      b {{ stats.details[0].ag_count_close }}
                    .text-medium-emphasis.text-uppercase.fw-semibold.small {{ $t("ui.closed") }}
            .col-lg-3.col-md-4.col-sm-6
              .card.card-glass
                .card-body.d-flex.align-items-center.p-2
                  .text-white.bg-primary.p-2.mr-3
                    i.icon-user.text-lg
                  .text-left
                    .fs-6.fw-semibold.text-danger
                      b {{ stats.details[0].ag_count_freeze }}
                    .text-medium-emphasis.text-uppercase.fw-semibold.small {{ $t("ui.freezed") }}
            .col-lg-3.col-md-4.col-sm-6
              .card.card-glass
                .card-body.d-flex.align-items-center.p-2
                  .text-white.bg-primary.p-2.mr-3
                    i.icon-user.text-lg
                  .text-left
                    .fs-6.fw-semibold.text-danger
                      b {{ stats.details[0].ag_count_suspend }}
                    .text-medium-emphasis.text-uppercase.fw-semibold.small {{ $t("ui.suspended") }}
            .col-lg-3.col-md-4.col-sm-6
              .card.card-glass
                .card-body.d-flex.align-items-center.p-2
                  .text-white.bg-info.p-2.mr-3
                    i.icon-people.text-lg
                  .text-left
                    .fs-6.fw-semibold.text-danger
                      b {{ stats.details[0].mb_count }}
                    .text-medium-emphasis.text-uppercase.fw-semibold.small {{ $t("ui.total") }} ({{ $t("ui.member") }})
          .row
            .col-12
              .card.card-glass
                .card-header.p-2
                  i.fa.fa-landmark.text-secondary
                  span.text-secondary {{ $t("ui.bank") }}
                .card-body.p-2
                  .table-responsive.mb-0(style="height: 200px;")
                    table.table.b-table.c-table.glass-table(role="table", aria-busy="false")
                      thead(role="rowgroup")
                        tr(role="row")
                          th(role="columnheader", scope="col", style="width: 100px;")
                            div {{ $t("ui.bank") }}
                          th.text-left(role="columnheader", scope="col" style="width: 160px;")
                            div {{ $t("ui.bank_acc_no") }}
                          th.text-left(role="columnheader", scope="col")
                            div {{ $t("ui.bank_acc_holder") }}
                          th.text-right(role="columnheader", scope="col", style="width: 120px;")
                            div {{ $t("ui.accumulate_incoming_amount") }}
                          th.text-right(role="columnheader", scope="col", style="width: 120px;")
                            div {{ $t("ui.accumulate_outgoing_amount") }}
                      tbody(v-if="stats.balance.length > 0" role="rowgroup")
                        template(v-for="(item, index) in stats.balance")
                          tr(role="row")
                            td(role="cell")
                              .text-left
                                span {{ item.bank_id }}
                            td(role="cell")
                              .text-left
                                span {{ item.bank_acc_no }}
                            td(role="cell")
                              .text-left
                                span {{ item.bank_acc_holder }}
                            td(role="cell")
                              .text-right
                                span(
                                  :class="$helpers.getNumberClass(item.accumulate_incoming_amount)"
                                  )
                                  | #[b {{ item.accumulate_incoming_amount | currency }}]
                            td(role="cell")
                              .text-right
                                span(
                                  :class="$helpers.getNumberClass(item.accumulate_outgoing_amount)"
                                  )
                                  | #[b {{ item.accumulate_outgoing_amount | currency }}]
          .row
            .col-12
              .card.card-glass
                .card-header.p-2
                  i.fa.fa-gamepad.text-secondary
                  span.text-secondary {{ $t("ui.platform") }}
                .card-body.p-2
                  .table-responsive.mb-0
                    table.table.b-table.c-table.glass-table(role="table", aria-busy="false")
                      thead(role="rowgroup")
                        tr(role="row")
                          th.text-left(role="columnheader", scope="col")
                            div {{ $t("ui.platform") }}
                          th.text-left(role="columnheader", scope="col" style="width: 160px;")
                            div {{ $t("ui.turnover") }}
                          th.text-right(role="columnheader", scope="col", style="width: 160px;")
                            div {{ $t("ui.valid_turnover") }}
                          th.text-right(role="columnheader", scope="col", style="width: 160px;")
                            div {{ $t("ui.winlose") }}
                      tbody(v-if="stats.platform.length > 0" role="rowgroup")
                        template(v-for="(item, index) in stats.platform")
                          tr(role="row")
                            td(role="cell")
                              .text-left
                                span {{ item.provider_type }}
                            td(role="cell")
                              .text-right
                                span(
                                  :class="$helpers.getNumberClass(item.turnover)"
                                  )
                                  | #[b {{ item.turnover | currency }}]
                            td(role="cell")
                              .text-right
                                span(
                                  :class="$helpers.getNumberClass(item.valid_turnover)"
                                  )
                                  | #[b {{ item.valid_turnover | currency }}]
                            td(role="cell")
                              .text-right
                                span(
                                  :class="$helpers.getNumberClass(item.winlose)"
                                  )
                                  | #[b {{ item.winlose | currency }}]
    asidebar
</template>

<script>
import errorTags from "@/errorTags";
import navbar from "@/components/navbar.vue";
import sidebar from "@/components/sidebar.vue";
import asidebar from "@/components/asidebar.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    navbar,
    sidebar,
    asidebar
  },
  data() {
    return {
      stats: {
        balance: [],
        details: [],
        lcbetlimit: [],
        lobetlimit: [],
        sbbetlimit: [],
        platform: [],
        providerlist: [],
      }
    };
  },
  validations: {},
  computed: {},
  mounted() {
    this.getList();
  },
  beforeDestroy() {},
  created() {},
  methods: {
    getList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        audit_by: this.$store.getters.username
      };

      xhr
        .doRequest(args, xhr.ACCOUNT.dashboard)
        .then(res => {
          // console.log(res);
          this.stats = res.data;
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    }
  }
};
</script>
